import dayjs from "dayjs";

import { formatNumber } from "helpers/formatNumber";
import { IWalletPendingItem } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  data: IWalletPendingItem;
}

export default function BrokerWalletPendingItem({ data }: Readonly<IProps>) {
  const createdDate = dayjs(data?.created).format("MM/DD/YYYY");

  return (
    <div className="pb-4.5">
      <ul className={styles.walletPendingItemContainer}>
        <li>
          <span className="font-bold">Date</span>
          <span>{createdDate}</span>
        </li>
        <li>
          <span className="font-bold">Description</span>
          <span>{data?.description}</span>
        </li>
        <li>
          <span className="font-bold">Invoice</span>
          <span>{data?.invoice_number}</span>
        </li>
        <li>
          <span className="font-bold">Credit</span>
          <span>{formatNumber(data?.credit_amount, 2)}</span>
        </li>
      </ul>
      <div className={styles.result}>
        <span>Debit</span>
        <span>{formatNumber(data?.debit_amount, 2)}</span>
      </div>
    </div>
  );
}
